import React, { useEffect, useState } from "react";
import { getContactUs, deleteContact } from "../../lib/firebase/firestore";
import styles from "../../styles/AdminTable.module.css";

type Contact = {
  id: string;
  name: string;
  email: string;
  phone: string;
  company: string;
  country: string;
  jobTitle: string;
  jobDetails: string;
  createdAt: any;
};

export const ContactsPage = () => {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedContactId, setSelectedContactId] = useState<string | null>(
    null
  );

  const fetchContacts = async () => {
    const data = await getContactUs();
    setContacts(data);
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  // Open dialog
  const openDialog = (id: string) => {
    setSelectedContactId(id);
    setDialogOpen(true);
  };

  // Confirm delete
  const confirmDelete = async () => {
    if (!selectedContactId) return;
    try {
      setLoading(true);
      await deleteContact(selectedContactId);
      setContacts((prev) => prev.filter((c) => c.id !== selectedContactId));
    } catch (error) {
      console.error("Error deleting contact:", error);
      alert("Failed to delete contact. Please try again.");
    } finally {
      setLoading(false);
      setDialogOpen(false);
      setSelectedContactId(null);
    }
  };

  // Cancel delete
  const cancelDelete = () => {
    setDialogOpen(false);
    setSelectedContactId(null);
  };

  const handleSendEmail = (email: string) => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div>
      <h2>Contact Submissions</h2>
      {contacts.length === 0 ? (
        <p>No contacts found.</p>
      ) : (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Company</th>
              <th>Country</th>
              <th>Job Title</th>
              <th>Job Details</th>
              <th>Submitted</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((c) => (
              <tr key={c.id}>
                <td>{c.name}</td>
                <td>{c.email}</td>
                <td>{c.phone}</td>
                <td>{c.company}</td>
                <td>{c.country}</td>
                <td>{c.jobTitle}</td>
                <td>{c.jobDetails}</td>
                <td>
                  {c.createdAt?.toDate
                    ? c.createdAt.toDate().toLocaleString()
                    : ""}
                </td>
                <td>
                  <button
                    onClick={() => handleSendEmail(c.email)}
                    className={styles.emailButton}
                  >
                    Send Email
                  </button>
                  <button
                    onClick={() => openDialog(c.id)}
                    disabled={loading}
                    className={styles.deleteButton}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Delete Confirmation Dialog */}
      {dialogOpen && (
        <div className={styles.dialogOverlay}>
          <div className={styles.dialogBox}>
            <p>Are you sure you want to delete this contact?</p>
            <div className={styles.dialogActions}>
              <button onClick={confirmDelete} className={styles.deleteButton}>
                Yes, Delete
              </button>
              <button onClick={cancelDelete} className={styles.cancelButton}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
